module.exports = __webpack_public_path__ + "img/logo.2a9f85f0.png";